export const CONNECT_SCREENS = {
  LINKED_PATIENTS: 'linked_patients',
  REFERRAL_ONE_PAGER: 'referral_one_pager',
  PROGRAMS: 'programs',
  NERVA_INFO: 'nerva_info',
  MY_ACCOUNT: 'my_account',
  SIGN_IN_OR_REGISTER: 'signIn_or_register',
  REGISTER: 'register',
  PASSWORD: 'password',
  NERVA_REFERRAL_FORM: 'nerva_referral_form',
} as const;

export type ConnectScreen = (typeof CONNECT_SCREENS)[keyof typeof CONNECT_SCREENS];

export enum MOBILE_OS {
  APPLE = 'ios',
  GOOGLE = 'android',
}

export enum USER_TYPE {
  HCP = 'hcp',
  PATIENT = 'patient',
}

export enum REFERRAL_URL_TYPE {
  QRCODE = 'qrcode',
  LINK = 'link',
}
